export default __webpack_public_path__ + "static/media/feature7_2.8fd178f8.png";